import { transitions } from 'polished';

export const createTransition = (
  properties = [],
  { duration = 0, delay = 0, easing }
) => {
  return transitions(properties, `${duration}ms ${easing} ${delay}ms`)
    .transition;
};
